import React from 'react';
import { RankingComponentProps } from 'types/ranking';
import { getAvatarImage } from 'utils/avatars';
import { getRankingTrophy } from 'utils/trophies';
import './styles.scss';

export function Top3Ranking({ players, title = "Top 3", className = "" }: RankingComponentProps) {
  const top3 = players.slice(0, 3);

  return (
    <div className={`top3-ranking ${className}`}>
      {title && <h2 className="ranking-title">{title}</h2>}

      <div className="players-container">
        {top3.map((player, index) => {
          const avatarImage = getAvatarImage(player.fotoDePerfil || player.avatar);
          const trophyImage = getRankingTrophy(player.position);

          return (
            <div key={player.id} className="player-item">
              <div className="player-avatar-container">
                <div className="avatar-wrapper">
                  {avatarImage ? (
                    <img src={avatarImage || "/placeholder.svg"} alt={player.name} className="player-avatar" />
                  ) : (
                    <div className="player-avatar-placeholder">{player.name.charAt(0).toUpperCase()}</div>
                  )}
                  {/* Troféu no canto inferior esquerdo */}
                  {trophyImage && (
                    <img
                      src={trophyImage || "/placeholder.svg"}
                      alt={`Troféu ${player.position}º lugar`}
                      className="avatar-trophy"
                    />
                  )}
                </div>
              </div>

              {/* Nome do Jogador */}
              <div className="player-name">{player.name}</div>
              <div className='text-white font-semibold bg-[#8b5cf6] bg-opacity-50 rounded-lg p-2 text-md border border-white/10 drop-shadow-md text-center min-w-[64px]'>{player.points} PTS</div>

              <div className="player-info">
                {player.teamName && (
                  <>
                    <span>Equipe {player.teamName}</span>
                    {player.location && (
                      <>
                        <span className="separator"> • </span>
                        <span>{player.location}</span>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          )
        })}
      </div>

      {/* Mensagem caso não haja dados suficientes */}
      {top3.length === 0 && <div className="no-data-message">Nenhum dado de ranking disponível</div>}
    </div>
  )
}
